module.exports = __webpack_public_path__ + "static/media/chef-3.29a5d5ed.jpg";